import { useEffect, useRef, useState } from "react"
import { SquadupState } from "./squadup/squadup-state"
import { useSquadup, useSquadupState } from "./useSquadUp"
import { useIsSSR } from "eddev/routing"

type Props = {
  className?: string
  name?: string
  enabled: boolean
  getPriority: (state: SquadupState, wasVisible: boolean) => number
  onVisibleChange: (visible: boolean, loading: boolean) => void
  onMount?: () => void
  onUnmount?: () => void
  hacks?: (root: HTMLDivElement) => void
}

export function SquadupEmbed(props: Props) {
  if (!env.client) return null
  const hydrating = useIsSSR()

  const el = useRef<HTMLDivElement>(null)
  const [visible, setVisible] = useState(false)
  const squadup = useSquadup()
  const state = useSquadupState()

  const getPriorityRef = useRef(props.getPriority)
  getPriorityRef.current = props.getPriority

  const hacksRef = useRef(props.hacks)
  hacksRef.current = props.hacks

  useEffect(() => {
    if (props.onMount) {
      props.onMount()
    }
    return () => {
      if (props.onUnmount) {
        props.onUnmount()
      }
    }
  }, [])

  useEffect(() => {
    if (props.enabled && !hydrating) {
      return squadup.state.registerContainerCandidate({
        element: el.current!,
        getPriority: (state, visible) => getPriorityRef.current(state, visible),
        onVisibleChange: setVisible,
      })
    }
  }, [props.enabled, hydrating])

  // useEffect(() => {
  //   if (props.open) {
  //     squadup.open(props.options);
  //   }
  // }, [props.open]);

  useEffect(() => {
    props.onVisibleChange(visible && state.open, visible && state.loading)
    if (visible) {
      squadup.state.applyHacks = (root) => hacksRef.current?.(root)
    }
  }, [visible, state.open, state.loading])

  if (hydrating) return null

  return <div id={props.name} ref={el} className={props.className}></div>
}
